import { mapState } from "vuex"

export default {
  data: () => ({
    fullnameSuggest: []
  }),
  computed: {
    ...mapState(['DaDataFIOUrl', 'DaDataToken'])
  },
  methods: {
    async suggestName(val) {
      let url = this.DaDataFIOUrl,
        token = this.DaDataToken,
        query = val,
        gender = 'UNKNOWN'

      let options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
        },
        body: JSON.stringify({ query, gender, count: 5 })
      }

      let sg = await(fetch(url, options)
        .then(response => response.json())
        .then(res => { return res.suggestions.map(el => ((el.data.surname || '') + ' ' + (el.data.name || '') + ' ' + (el.data.patronymic || '')).replace(/\s+/g, ' ').trim()) })
        .catch(() => []))

      this.fullnameSuggest = sg
    },
    async suggestNameAndReturn(val) {
      let url = this.DaDataFIOUrl,
        token = this.DaDataToken,
        query = val,
        gender = 'UNKNOWN'

      let options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
        },
        body: JSON.stringify({ query, gender, count: 5 })
      }

      let sg = await(fetch(url, options)
        .then(response => response.json())
        .then(res => { return res.suggestions.map(el => ((el.data.surname || '') + ' ' + (el.data.name || '') + ' ' + (el.data.patronymic || '')).replace(/\s+/g, ' ').trim()) })
        .catch(() => []))

      return sg
    }
  }
}